var exports = {
  "ed": "PurchaseDisclaimer.module__disclaimer___X3Q5em",
  "gX": "PurchaseDisclaimer.module__center___X3Q5em",
  "kb": "PurchaseDisclaimer.module__left___X3Q5em",
};

module.exports = exports;
